/**
 * Packaging OS — header used on public surfaces (Landing, Login, Preview).
 *
 * Logo + nav (minimal) + global LanguageSwitcher.
 */

import { Link, useLocation } from "react-router-dom";
import { LanguageSwitcher } from "./LanguageSwitcher";
import type { LocaleCode } from "../i18n/locales";

interface PublicHeaderProps {
  locale: LocaleCode;
  onLocaleChange: (next: LocaleCode) => void;
  switchLanguageLabel: string;
  brand: string;
  navLinks: Array<{ to: string; label: string }>;
}

export function PublicHeader({
  locale,
  onLocaleChange,
  switchLanguageLabel,
  brand,
  navLinks,
}: PublicHeaderProps): JSX.Element {
  const location = useLocation();
  return (
    <header className="po-header">
      <Link to="/" className="po-header__brand" aria-label={brand}>
        {brand}
      </Link>
      <nav className="po-header__nav" aria-label="primary">
        {navLinks.map((link) => {
          const current = location.pathname === link.to;
          return (
            <Link
              key={link.to}
              to={link.to}
              className="po-header__nav-item"
              aria-current={current ? "page" : undefined}
            >
              {link.label}
            </Link>
          );
        })}
      </nav>
      <div className="po-header__group">
        <LanguageSwitcher
          current={locale}
          onChange={onLocaleChange}
          groupLabel={switchLanguageLabel}
        />
      </div>
    </header>
  );
}
